import request from '@/utils/request'; // 服务名：ecargocredit--申报相关接口
// 一个保单申报查询

export function getDeclareQueryAll(data) {
  return request({
    url: '/ecargocredit/declare/declareQueryAll',
    method: 'post',
    data: data
  });
} // 申报记录详情

export function getDeclareList(data) {
  return request({
    url: '/ecargocredit/declare/declareList',
    method: 'post',
    data: data
  });
}
export function pageInit(data) {
  return request({
    url: '/ecargocredit/declarePage/pageInit',
    method: 'post',
    data: data
  });
}
export function saveOrUpdateDeclareDetail(data) {
  return request({
    url: '/ecargocredit/declare/saveOrUpdateDeclareDetail',
    method: 'post',
    data: data
  });
}
export function updateDeclareStatus(data) {
  return request({
    url: '/ecargocredit/declare/updateDeclareStatus',
    method: 'post',
    data: data
  });
} // 出口运输申报记录查询（保险公司专用）

export function declarePolicyPageInfoByCompany(data) {
  return request({
    url: '/ecargocredit/declare/declarePolicyPageInfoByCompany',
    method: 'post',
    data: data
  });
} // 出口运输申报记录查询

export function declarePolicyPageInfo(data) {
  return request({
    url: '/ecargocredit/declare/declarePolicyPageInfo',
    method: 'post',
    data: data
  });
}
export function getCountry() {
  return request({
    url: '/ecargocredit/creditCommon/getCountry',
    method: 'post',
    data: null
  });
}